module.exports = __webpack_public_path__ + "static/HighLights-795cdb44892ccf9b72fe5c307a6c2a72.jpg";